/*
  The icons a case's info block offers for its feature tiles ("Структура", "UX",
  "Интеграции"...).

  The editor offered four (activity, database, shield, cpu), copied into the editor, the
  save and the page. One list now, read by all three; a stored name that is not on it
  falls back to the default instead of breaking the page. The four old values keep
  their names, so stored cases are unchanged.
*/

export const FEATURE_ICONS = [
  { value: 'activity', label: 'Активность' },
  { value: 'database', label: 'База данных' },
  { value: 'shield', label: 'Защита' },
  { value: 'cpu', label: 'Процессор' },
  { value: 'code', label: 'Код, разработка' },
  { value: 'server', label: 'Сервер, хостинг' },
  { value: 'cloud', label: 'Облако' },
  { value: 'lock', label: 'Безопасность, доступ' },
  { value: 'smartphone', label: 'Мобильная версия' },
  { value: 'monitor', label: 'Десктоп, интерфейс' },
  { value: 'layout', label: 'Структура, макет' },
  { value: 'palette', label: 'Дизайн' },
  { value: 'search', label: 'Поиск, SEO' },
  { value: 'chart', label: 'Аналитика' },
  { value: 'gauge', label: 'Скорость' },
  { value: 'plug', label: 'Интеграции' },
  { value: 'workflow', label: 'Процессы, автоматизация' },
  { value: 'puzzle', label: 'Модули' },
  { value: 'settings', label: 'Настройки, админка' },
  { value: 'bot', label: 'Боты, ИИ' },
  { value: 'mail', label: 'Почта, рассылки' },
  { value: 'message', label: 'Чат, мессенджеры' },
  { value: 'bell', label: 'Уведомления' },
  { value: 'calendar', label: 'Запись, бронирование' },
  { value: 'map', label: 'Карта, адреса' },
  { value: 'card', label: 'Оплата' },
  { value: 'cart', label: 'Корзина, заказ' },
  { value: 'store', label: 'Магазин' },
  { value: 'boxes', label: 'Каталог, склад' },
  { value: 'file', label: 'Документы' },
  { value: 'image', label: 'Галерея, медиа' },
  { value: 'video', label: 'Видео' },
  { value: 'language', label: 'Языки' },
  { value: 'users', label: 'Аудитория, клиенты' },
  { value: 'headphones', label: 'Поддержка' },
  { value: 'megaphone', label: 'Реклама' },
  { value: 'lightbulb', label: 'Идея' },
  { value: 'rocket', label: 'Запуск' },
  { value: 'check', label: 'Контроль качества' },
] as const

export type FeatureIcon = (typeof FEATURE_ICONS)[number]['value']

export const DEFAULT_FEATURE_ICON: FeatureIcon = 'activity'

const FEATURE_ICON_VALUES: ReadonlySet<string> = new Set(FEATURE_ICONS.map((i) => i.value))

/** A stored icon name, or the default for anything not in the list. */
export function normalizeFeatureIcon(value: unknown): FeatureIcon {
  return typeof value === 'string' && FEATURE_ICON_VALUES.has(value)
    ? (value as FeatureIcon)
    : DEFAULT_FEATURE_ICON
}
